var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2642 18.0724C35.9698 16.9414 35.1023 16.0508 34.0008 15.7485C32.0046 15.1992 23.9992 15.1992 23.9992 15.1992C23.9992 15.1992 15.9938 15.1992 13.9975 15.7485C12.8959 16.0508 12.0285 16.9414 11.7341 18.0724C11.1992 20.1223 11.1992 24.3992 11.1992 24.3992C11.1992 24.3992 11.1992 28.676 11.7341 30.726C12.0285 31.857 12.8959 32.7476 13.9975 33.05C15.9938 33.5992 23.9992 33.5992 23.9992 33.5992C23.9992 33.5992 32.0046 33.5992 34.0008 33.05C35.1023 32.7476 35.9698 31.857 36.2642 30.726C36.7992 28.676 36.7992 24.3992 36.7992 24.3992C36.7992 24.3992 36.7992 20.1223 36.2642 18.0724Z",
    fill: "#231C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5996 28.8008V20.8008L27.9996 24.8009L21.5996 28.8008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubewhite);
export default __webpack_public_path__ + "static/media/Youtube white.a0a86d005ca3bba2df5e7a7e1823acab.svg";
export { ForwardRef as ReactComponent };